export default "__VITE_ASSET__DDBDwbPi__"